module.exports = __webpack_public_path__ + "img/P37920580EHA.3fc495a9.jpg";